export default {"src":"/_next/static/media/favicon.50bd4bd6.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};